import PropTypes from 'prop-types';
export default (function () {
  var dataShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PropTypes.any;
  return PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    data: dataShape,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
  });
});
export var defaultThunkValue = function defaultThunkValue() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    loading: false,
    loaded: false,
    data: defaultValue
  };
};